import router from "./router"; //导入路由文件
import store from './store'; //导入全局变量
import { getPageTitle } from "./utils"; //页面标题 
import Auth from "./utils/auth"; //身份验证

import Loading from "./utils/Loading"; //获取加载组件

const whiteList = ["Login"]; // 重定向白名单

//全局路由守卫
router.beforeEach((to,from,next) => {
	//to = 当前点击路由的相关信息
	//获取当前点击路径 to.path
	//from = 当前将要离开路由相关信息
	//next规则如下：
	//在守卫方法中如果不声明next形参，则默认允许用户访问每一个路由。
	//在守卫方法中如果声明了next形参，则必须调用next()函数，否则不允许用户访问任何一个路由。
	//next() = 放行
	//next(false) = 强制停留当前页
	//next('') = 强制用户跳转至指定页面
	
	Loading.LoadingShow();
	
    // 页面标题
    document.title = getPageTitle(to.meta.title);

	if(Auth.getToken()){
		//有Token
		console.log('TokenIn');

		//路由判断-开始
		let PowerWhiteList = ["/Home"]; // 权限白名单

		let Info = JSON.parse(Auth.getInfo());
		let MenuJsonData = Info.Menu;

		//循环权限菜单
		function ForMenu(Data){
			for (let i = 0; i < Data.length; i++) { 
				if(Data[i].Children.length >= 1){
					ForMenu(Data[i].Children);
				}
				PowerWhiteList.push(Data[i].Path);
			}
		}

		ForMenu(MenuJsonData); //执行权限菜单
		PowerWhiteList = JSON.stringify(PowerWhiteList);
		// console.log(PowerWhiteList);
		// console.log(to.path);
		// console.log(PowerWhiteList.indexOf(to.path));
		//路由判断-结束

		//console.log(to.name);
		//检查权限白名单
		if (PowerWhiteList.indexOf(to.path) !== -1) {
			//成功通过
			if(to.name === "Login"){
				//用户需要访问登录页
				//让其跳转进主页
				next("/Home");
			}else{
				//判断权限
				next();
			}
		}else{
			//禁止通过
			Auth.removeToken();
			Auth.removeInfo();
			next("/Login");
		}
	}else{
		//未登录，没有Token
		console.log('TokenNull');
		//检查白名单列表
		if (whiteList.indexOf(to.name) !== -1) {
		  next();
		} else {
		  // 未登录则跳转到登录页
		  next("/Login");
		}
	}

	//console.log(to.path);
	//console.log('Ok');
	
	// if(to.path == '/My'){
	// 	next('/about');
	// }else{
	// 	next();
	// }

	Loading.LoadingHide();
})